/**
 * Beta gate per le route del dominio AI Agents (/agents/*).
 *
 * Se l'org corrente non e` in BETA_AGENTS_ORG_IDS, redirect a / (home).
 * Non sostituisce ProtectedRoute: si usano insieme.
 *   <BetaAgentsRoute>
 *     <ProtectedRoute resource="agents" action="view">
 *       <AgentsPage />
 *     </ProtectedRoute>
 *   </BetaAgentsRoute>
 *
 * Quando il beta finisce: rimuovere wrapper dalle route in App.tsx + svuotare
 * BETA_AGENTS_ORG_IDS (vedi config/betaOrgs.ts).
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserData } from '../lib/auth';
import { BETA_AGENTS_ORG_IDS, canAccessBetaFeature } from '../lib/config/betaOrgs';

interface Props {
  children: React.ReactNode;
}

export function BetaAgentsRoute({ children }: Props) {
  const { organizationId, loading } = useUserData();

  // Aspetta il caricamento dei dati org prima di decidere (evita redirect spurio
  // durante il primo render della SPA).
  if (loading) return null;

  if (!canAccessBetaFeature(BETA_AGENTS_ORG_IDS, organizationId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
